<template>
  <div class="d-flex padding">
    <div class="padding-text" @click="back">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 0.999998 12 0.999998C18.0751 0.999998 23 5.92487 23 12ZM13.7071 15.7071C13.3166 16.0976 12.6834 16.0976 12.2929 15.7071L9.29289 12.7071C9.10536 12.5196 9 12.2652 9 12C9 11.7348 9.10536 11.4804 9.29289 11.2929L12.2929 8.29289C12.6834 7.90236 13.3166 7.90236 13.7071 8.29289C14.0976 8.68341 14.0976 9.31658 13.7071 9.7071L11.4142 12L13.7071 14.2929C14.0976 14.6834 14.0976 15.3166 13.7071 15.7071Z"
          fill="#206CFE"
        />
      </svg>
    </div>
    <p class="f-Overpass f-w-700 f-24 m-0 padding-text p-0">
      {{ headerTitle }}
    </p>
  </div>
</template>

<script>
export default {
  name: "titleBar",
  props: {
    headerTitle: String,
  },
  methods: {
    back() {
      this.$emit("back");
    },
  },
};
</script>
<style scoped>
.padding-text {
  padding-top: 3px;
}

.padding {
  padding: 16px 20px;
  gap: 12px;
}
</style>
